<div class="joblist-row employerlist" *ngFor="let i of [1,2,3,4,5]">
    <div class="jobpost">
      <div class="jobheading location-detail">
        <figure><a href="javascript:void(0);"><ngx-skeleton-loader [theme]="{ width: '30px', height: '30px', 'border-radius': '0px'}" appearance="circle"></ngx-skeleton-loader></a></figure>
        <h4><ngx-skeleton-loader [theme]="{ width: '60%'}" ></ngx-skeleton-loader></h4>
        <ul class="icon-heighlight">
            <li><ngx-skeleton-loader></ngx-skeleton-loader></li>
            <li><ngx-skeleton-loader></ngx-skeleton-loader></li>
            <li><ngx-skeleton-loader></ngx-skeleton-loader></li>
            <li><ngx-skeleton-loader></ngx-skeleton-loader></li>
        </ul>
      </div>
    </div>
    <div class="employerdetail">
      <div><ngx-skeleton-loader count="1"></ngx-skeleton-loader></div>                             
    </div>
</div>
